export const containerStyles: React.CSSProperties = {
  position: 'relative',
  fontSize: '1rem',
  fontWeight: 500,
}

export const inputStyles: React.CSSProperties = {
  height: '57px',
  width: '100%',
  fontSize: '16px',
  fontWeight: 500,
  border: '1px solid #c0c0c0',
  borderRadius: '4px',
  boxSizing: 'border-box',
  padding: '16px',
}

export const labelStyles: React.CSSProperties = {
  position: 'absolute',
  pointerEvents: 'none',
  top: 0,
  bottom: 0,
  margin: 0,
  height: '50%',
  left: '12px',
  color: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  transform: 'translate(0, -50%)',
  backgroundColor: 'white',
  paddingLeft: '4px',
  paddingRight: '4px',
}

export const helperTextStyles: React.CSSProperties = {
  color: 'rgba(0, 0, 0, 0.6)',
  fontWeight: 400,
  fontSize: '0.75rem',
  lineHeight: 1.66,
  textAlign: 'left',
  marginTop: '3px',
  marginRight: '14px',
  marginBottom: 0,
  marginLeft: '14px',
}
